export default "__VITE_ASSET__Cth0Ya9w__"